<template>
  <div class="card-detail-request">
    <header>
      <div
        aria-label="Icono de usuario pendiente de verificación"
        :class="{
          'icon-container' : true,
        }"
      >
        <i
          :class="{
            'icon-container__icon' : true,
            'pi pi-clock': true,
          }"
        ></i>
      </div>
      <h1>
        Tu solicitud ha quedado registrada.
      </h1>
    </header>
    <section>
      <div class="body__description">
        <p>
          Tus datos estan pendientes de verificar,
          te enviaremos un mensaje cuando se haya completado la verificación.
        </p>
        <p>
          También puedes volver en cualquier momento para
          consultar el estado de tu registro:
          <a href="https://veranojoven.transportes.gob.es">
            https://veranojoven.transportes.gob.es</a>
        </p>
        <p>Gracias.</p>
      </div>
    </section>
    <footer>
      <div class="footer">
        <p class="footer__date">
          <span>Fecha de registro:</span>
          <span>
            <strong>
              {{ transformTimestampStringNotDateWhithOutHour(state$$.detailModel?.registeredDate) }}
            </strong>
          </span>
        </p>
      </div>
    </footer>
  </div>
</template>

<script setup>
// #region VUE
import {
  inject,
} from 'vue';
// #endregion

// #region COMPONENTS COMPOSABLES
import useTransformToTimestampString from '@/composables/transform-timestamp-string';
// #endregion

// #region Props, Emits
// ...
// #endregion

// #region Params, Ref, Reactives, Computed
const state$$ = inject('detailRequestState$$');
const {transformTimestampStringNotDateWhithOutHour} = useTransformToTimestampString();
// #endregion

// #region Functions
// ...
// #endregion

// #region Effects, Hooks
// ...
// #endregion

// #region Provide, Expose
// ...
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;
.card-detail-request{
  align-items: center;
  display: flex;
  flex-direction: column;

  gap: $brand__boxspace--medium;
  padding: $brand__boxspace--medium * 2;

  header, section, footer{
    align-items: center;
    display: flex;
    flex-direction: column;

    text-align: center;

    gap: $brand__boxspace--medium;
  }

  header{
    gap: $brand__boxspace--medium * 2;
    .icon-container{
      background-color: $pv__color--green-alter;
      border-radius: $pv__br--circle;
      color: $pv__color--white;
      flex: 1;
      padding: $brand__boxspace--medium;
      width: fit-content;
      &__icon{
        @include media("<=phone") {
          font-size: $pv__dm__icon--largue;
        }
        @include media(">phone") {
          font-size: $pv__dm__icon--largue;
        }
      }
    }
  }

  section{
    .body__description{
      align-items: center;
      display: flex;
      flex-direction: column;
      & p {
        font-size: $pv__fs--large;
        & a{
          color: $pv__color--green-alter;
          text-decoration: underline;
        }
      }
    }
  }

  footer{
    .footer{
      &__date {
        align-items: center;
        display: flex;
        font-size: $pv__fs--large;
        gap: $brand__boxspace--small;
        justify-content: center;
        @include media("<=phone") {
          flex-direction: column;
        }
        @include media(">phone") {
          flex-direction: row;
        }
      }
    }
    .footer__keypad{
      align-items: center;
      display: flex;
      gap: $brand__boxspace--medium;
      justify-content: center;
      margin-top: $brand__boxspace--medium * 3;

      @include media("<=phone") {
        flex-direction: column;
      }
      @include media(">phone") {
        flex-direction: row;
      }

      & button{
        width: fit-content;
      }
    }
  }
}
</style>
